<template>
    <div>
       <div class="backcolor">
                <div>
                    <ul class="nav">                                       
                        <li class="nav-item" v-for="item in this.route_AsyncRouter" :class="{'is-active':isActive}">
                            <router-link  v-if="item.children.length == 1" class="linka" :to= "item.redirect+'/'+'?id='+item.id">{{item.name}}
                                <!-- <svg v-if="item.children.length > 1" t="1570847469192" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3415"><path d="M777.045333 345.642667 512 611.648 246.976 345.642667c-12.565333-12.629333-32.981333-12.629333-45.546667 0s-12.565333 33.130667 0 45.76L487.616 678.613333c6.698667 6.741333 15.594667 9.6 24.384 9.173333 8.789333 0.448 17.664-2.410667 24.384-9.173333l286.208-287.210667c12.544-12.629333 12.544-33.130667 0-45.76C810.005333 333.013333 789.632 333.013333 777.045333 345.642667z" p-id="3416" fill="#ffffff"></path></svg> -->
                            </router-link>
                            <a class="linka" v-else>{{item.name}}
                                <svg t="1570847469192" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3415"><path d="M777.045333 345.642667 512 611.648 246.976 345.642667c-12.565333-12.629333-32.981333-12.629333-45.546667 0s-12.565333 33.130667 0 45.76L487.616 678.613333c6.698667 6.741333 15.594667 9.6 24.384 9.173333 8.789333 0.448 17.664-2.410667 24.384-9.173333l286.208-287.210667c12.544-12.629333 12.544-33.130667 0-45.76C810.005333 333.013333 789.632 333.013333 777.045333 345.642667z" p-id="3416" fill="#ffffff"></path></svg>
                            </a>
                            <ul v-if="item.children.length > 1">
                                <li v-for="i in item.labelList" v-if="!item.hidden">
                                    <router-link :to = "'/'+item.path+'/'+i.path+'/'+'?id='+i.id" >{{i.name}}</router-link>
                                </li>
                            </ul>
                        </li>                                       
                    </ul>
                </div>
        </div>
    </div>
</template>
<script>
import { lableRoute } from '@/api/user'
export default {
    name:'Nav',
    data(){
        return{
           route:[],
           AsyncRouter:[],
           route_AsyncRouter:'',
           reoute_children:'',
           children:[], //存前台子路由
           LabelList:[], //存放后台子路由
           labelLis_children:'',
           isActive : true,
           languageId:localStorage.getItem("key"),
        }
    },
    mounted(){
        this.getRouters();
    },
    methods:{
        getRouters(){
            this.route = this.$router.options.routes;
            if(localStorage.getItem("key") == null){
                localStorage.setItem("value",'1')
                this.languageId = localStorage.getItem("value") 
            }
            lableRoute(this.languageId).then(res => {
                // localStorage.getItem("pi",)
                this.AsyncRouter = res.data.list;
                var Array_ = [];
                var Array_list = this.route.map((item_)=> {
                    Array_ = this.AsyncRouter.filter((item_t)=>{
                　　　　return item_t.sort == item_.id;
                　　});
                　　return Object.assign(item_,Array_[0]);
                });
                
                this.route_AsyncRouter = Array_list;
            })
        },
    }
  
}

</script>
<style scoped>
.backcolor{
  width: 80%;
  margin: auto;
  font-size: .4rem;
}
.content{
  margin: auto;
  background: blue;
}
.nav{
    width: 100%;
    height: 1.3rem;
    line-height: 1.3rem;
}
.nav-item{
    width: 12.5%;   
    float: left;
    margin: 0;
    position: relative;
    box-sizing: border-box;
    transition: border-color .3s,background-color .3s,color .3s;
    white-space: nowrap;
    display: list-item;
    text-align: center;
}
.nav-item svg{
    width: .5rem;
    height: 1.1rem;
    position: absolute;
}
.linka{
    display: inline-block;
    cursor: pointer;
    height: 1rem;
    line-height: 1.1rem;
    color: #feffff;
}
.nav-item ul{
    position: absolute;
    display: none;
    min-width: 100%;
    z-index: 100;
    border-radius: 0 0 10px 10px;
}
.nav-item:hover ul{
    display: block;
}
.nav-item ul li{
    line-height: 1.3rem;
    text-align: center;
    background: #ffffff;
    overflow: hidden;
}
.nav-item ul li:hover{
    background: #1B56A7;
}
.nav-item ul  li:last-child{
    border-radius: 0 0 6px 6px;
}
.nav-item ul li a{
    line-height: 1.3rem;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    color: #343434;
    min-width: 100%;
}
.nav-item ul li a:hover{
    color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/Nav.vue